import React from 'react'
import styled from 'styled-components'

import { Header } from './header'
import { Detail } from './detail'

export const Item = React.memo(({
  data,
  crRevenue,
  progressIndex,
  isExpand,
  isEditing,
  profitData,
  handleInput,
  handleRemark,
  handleExpandTable,
}) => {
  const { lobs = [], type } = data

  return (
    <Root>
      <Header
        data={ data }
        crRevenue={ crRevenue }
        index={ progressIndex }
        isExpand={ isExpand }
        profitData={ profitData }
        handleExpandTable={ handleExpandTable }
      />
      {lobs.map((lob, index) => (
        <DetailWrapper key={ index } expand={ isExpand }>
          <Detail
            data={ lob }
            type={ type }
            index={ index }
            progressIndex={ progressIndex }
            isExpand={ isExpand }
            isEditing={ isEditing }
            handleInput={ handleInput }
            handleRemark={ handleRemark }
          />
        </DetailWrapper>
      ))}
    </Root>
  )
})

const Root = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: 8px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);

  :nth-last-child(1) {
    margin: 0;
  }
`

const DetailWrapper = styled.div`
  display: ${p => (p.expand ? 'flex' : 'none')};
  flex-direction: column;
  background: #fff;
`



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/PercentTable/item/index.js